// customer video stills (data-poster) load when their row comes within 600px of the screen. First in the file so an
// error further down cannot leave the tiles without a still.
// The row is watched, not each video: on phones the row scrolls sideways and clips the later videos.
(function () {
  function stills(row) { row.querySelectorAll('video[data-poster]').forEach(function (v) { v.setAttribute('poster', v.getAttribute('data-poster')); v.removeAttribute('data-poster'); }); }
  var rows = document.querySelectorAll('.wlb-ugc');
  if (!('IntersectionObserver' in window)) { rows.forEach(stills); return; }
  var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { stills(e.target); io.unobserve(e.target); } }); }, { rootMargin: '600px 0px' });
  rows.forEach(function (r) { io.observe(r); });
})();

    document.addEventListener('DOMContentLoaded', function () {
      var section = document.querySelector('.review-quiz-section--quiz-reviews-carousel-quiz');
      if (!section) return;
      var viewport = section.querySelector('.review-quiz-carousel__viewport');
      var track = section.querySelector('.review-quiz-carousel__track');
      var prevBtn = section.querySelector('.review-quiz-carousel__arrow--prev');
      var nextBtn = section.querySelector('.review-quiz-carousel__arrow--next');
      var progressFill = section.querySelector('.review-quiz-carousel__progress-fill');
      if (!viewport || !track || !prevBtn || !nextBtn) return;
      var cards = track.querySelectorAll('.review-quiz-carousel__card');
      var totalCards = cards.length;
      if (totalCards === 0) return;
      var currentIndex = 0;
      var gap = 0;
      var step = 0;
      var maxIndex = 0;
      function updateStep() {
        if (cards[0]) {
          var w = cards[0].getBoundingClientRect().width;
          if (!w || !isFinite(w)) {
            w = cards[0].offsetWidth;
          }
          step = (w || 1) + gap;
          var viewportWidth = viewport.getBoundingClientRect().width || viewport.offsetWidth;
          var visibleCount = Math.max(1, Math.floor((viewportWidth + gap) / Math.max(step, 1)));
          maxIndex = Math.max(0, totalCards - visibleCount);
        }
      }
      function updateProgress() {
        if (!progressFill) return;
        var totalSteps = maxIndex <= 0 ? 1 : maxIndex + 1;
        var percentage = totalSteps <= 1 ? 100 : ((currentIndex + 1) / totalSteps) * 100;
        if (!isFinite(percentage)) {
          percentage = 100;
        }
        progressFill.style.width = percentage + '%';
      }
      function applyTransform() {
        updateStep();
        var offset = -currentIndex * step;
        track.style.transition = '';
        track.style.transform = 'translate3d(' + offset + 'px, 0, 0)';
        updateProgress();
      }
      function goNext() {
        if (currentIndex < maxIndex) {
          currentIndex++;
        } else {
          currentIndex = 0;
        }
        applyTransform();
      }
      function goPrev() {
        if (currentIndex > 0) {
          currentIndex--;
        } else {
          currentIndex = maxIndex;
        }
        applyTransform();
      }
      function dragBaseOffset() {
        updateStep();
        return -currentIndex * step;
      }
      function setTrackPx(px) {
        track.style.transform = 'translate3d(' + px + 'px, 0, 0)';
      }
      var swipe = { active: false, startX: 0, dx: 0, pointerId: null };
      function swipePointerEnd() {
        if (!swipe.active) return;
        swipe.active = false;
        if (viewport.releasePointerCapture && swipe.pointerId != null) {
          try { viewport.releasePointerCapture(swipe.pointerId); } catch (err) {}
        }
        swipe.pointerId = null;
        track.style.transition = '';
        updateStep();
        var thr = Math.max(40, Math.min(80, (step || 1) * 0.2));
        if (swipe.dx <= -thr) {
          goNext();
        } else if (swipe.dx >= thr) {
          goPrev();
        } else {
          applyTransform();
        }
        swipe.dx = 0;
      }
      function onSwipePointerDown(e) {
        if (swipe.active) return;
        if (typeof e.button === 'number' && e.button !== 0) return;
        swipe.active = true;
        swipe.startX = e.clientX;
        swipe.dx = 0;
        swipe.pointerId = e.pointerId != null ? e.pointerId : null;
        track.style.transition = 'none';
        if (viewport.setPointerCapture && swipe.pointerId != null) {
          try { viewport.setPointerCapture(swipe.pointerId); } catch (err) {}
        }
      }
      function onSwipePointerMove(e) {
        if (!swipe.active) return;
        swipe.dx = e.clientX - swipe.startX;
        setTrackPx(dragBaseOffset() + swipe.dx);
      }
      function onSwipeTouchStart(e) {
        if (swipe.active) return;
        if (!e.touches || !e.touches[0]) return;
        swipe.active = true;
        swipe.pointerId = null;
        swipe.startX = e.touches[0].clientX;
        swipe.dx = 0;
        track.style.transition = 'none';
      }
      function onSwipeTouchMove(e) {
        if (!swipe.active || !e.touches[0]) return;
        swipe.dx = e.touches[0].clientX - swipe.startX;
        setTrackPx(dragBaseOffset() + swipe.dx);
      }
      function onSwipeTouchEnd() {
        if (!swipe.active) return;
        swipe.active = false;
        track.style.transition = '';
        updateStep();
        var thr = Math.max(40, Math.min(80, (step || 1) * 0.2));
        if (swipe.dx <= -thr) {
          goNext();
        } else if (swipe.dx >= thr) {
          goPrev();
        } else {
          applyTransform();
        }
        swipe.dx = 0;
      }
      if (window.PointerEvent) {
        viewport.addEventListener('pointerdown', onSwipePointerDown);
        viewport.addEventListener('pointermove', onSwipePointerMove);
        viewport.addEventListener('pointerup', swipePointerEnd);
        viewport.addEventListener('pointercancel', swipePointerEnd);
      } else {
        viewport.addEventListener('touchstart', onSwipeTouchStart, { passive: true });
        viewport.addEventListener('touchmove', onSwipeTouchMove, { passive: true });
        viewport.addEventListener('touchend', onSwipeTouchEnd);
        viewport.addEventListener('touchcancel', onSwipeTouchEnd);
      }
      prevBtn.addEventListener('click', goPrev);
      nextBtn.addEventListener('click', goNext);
      if (typeof ResizeObserver !== 'undefined') {
        var ro = new ResizeObserver(function () {
          applyTransform();
        });
        ro.observe(viewport);
      }
      window.addEventListener('resize', applyTransform);
      applyTransform();
      requestAnimationFrame(function () {
        applyTransform();
      });
    });
  
;

    (function() {
      var section = document.getElementById('quiz-community');
      if (!section) return;
      var headers = section.querySelectorAll('.quiz-community__list-header');
      headers.forEach(function(header) {
        header.addEventListener('click', function() {
          var item = header.closest('[data-accordion-item]');
          var detail = header.getAttribute('aria-controls') && document.getElementById(header.getAttribute('aria-controls'));
          var toggleEl = header.querySelector('.quiz-community__list-toggle');
          var isOpen = item && item.classList.contains('is-open');
          if (item) item.classList.toggle('is-open', !isOpen);
          if (header) header.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
          if (toggleEl) toggleEl.textContent = isOpen ? '+' : '−';
        });
        header.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); header.click(); }
        });
      });
    })();
  
;

    document.addEventListener('DOMContentLoaded', function () {
      var section = document.querySelector('.reasons-section--reasons-carousel-quiz');
      if (!section) return;
      var viewport = section.querySelector('.reasons-carousel__viewport');
      var track = section.querySelector('.reasons-carousel__track');
      var prevBtn = section.querySelector('.reasons-carousel__arrow--prev');
      var nextBtn = section.querySelector('.reasons-carousel__arrow--next');
      var progressFill = section.querySelector('.reasons-carousel__progress-fill');
      if (!viewport || !track || !prevBtn || !nextBtn) return;
      var cards = track.querySelectorAll('.reasons-carousel__card');
      var totalCards = cards.length;
      if (totalCards === 0) return;
      var currentIndex = 0;
      var gap = 0;
      var step = 0;
      var maxIndex = 0;
      function updateStep() {
        if (cards[0]) {
          step = cards[0].offsetWidth + gap;
          var viewportWidth = viewport.offsetWidth;
          var visibleCount = Math.max(1, Math.floor((viewportWidth + gap) / step));
          maxIndex = Math.max(0, totalCards - visibleCount);
        }
      }
      function updateProgress() {
        if (!progressFill) return;
        var totalSteps = maxIndex <= 0 ? 1 : (maxIndex + 1);
        var percentage = totalSteps <= 1 ? 100 : ((currentIndex + 1) / totalSteps) * 100;
        progressFill.style.width = percentage + '%';
      }
      function applyTransform() {
        updateStep();
        var offset = -currentIndex * step;
        track.style.transition = '';
        track.style.transform = 'translate3d(' + offset + 'px, 0, 0)';
        updateProgress();
      }
      function goNext() {
        if (currentIndex < maxIndex) {
          currentIndex++;
        } else {
          currentIndex = 0;
        }
        applyTransform();
      }
      function goPrev() {
        if (currentIndex > 0) {
          currentIndex--;
        } else {
          currentIndex = maxIndex;
        }
        applyTransform();
      }
      function dragBaseOffset() {
        updateStep();
        return -currentIndex * step;
      }
      function setTrackPx(px) {
        track.style.transform = 'translate3d(' + px + 'px, 0, 0)';
      }
      var swipe = { active: false, startX: 0, dx: 0, pointerId: null };
      function swipePointerEnd() {
        if (!swipe.active) return;
        swipe.active = false;
        if (viewport.releasePointerCapture && swipe.pointerId != null) {
          try { viewport.releasePointerCapture(swipe.pointerId); } catch (err) {}
        }
        swipe.pointerId = null;
        track.style.transition = '';
        updateStep();
        var thr = Math.max(40, Math.min(80, (step || 1) * 0.2));
        if (swipe.dx <= -thr) {
          goNext();
        } else if (swipe.dx >= thr) {
          goPrev();
        } else {
          applyTransform();
        }
        swipe.dx = 0;
      }
      function onSwipePointerDown(e) {
        if (swipe.active) return;
        if (typeof e.button === 'number' && e.button !== 0) return;
        swipe.active = true;
        swipe.startX = e.clientX;
        swipe.dx = 0;
        swipe.pointerId = e.pointerId != null ? e.pointerId : null;
        track.style.transition = 'none';
        if (viewport.setPointerCapture && swipe.pointerId != null) {
          try { viewport.setPointerCapture(swipe.pointerId); } catch (err) {}
        }
      }
      function onSwipePointerMove(e) {
        if (!swipe.active) return;
        swipe.dx = e.clientX - swipe.startX;
        setTrackPx(dragBaseOffset() + swipe.dx);
      }
      function onSwipeTouchStart(e) {
        if (swipe.active) return;
        if (!e.touches || !e.touches[0]) return;
        swipe.active = true;
        swipe.pointerId = null;
        swipe.startX = e.touches[0].clientX;
        swipe.dx = 0;
        track.style.transition = 'none';
      }
      function onSwipeTouchMove(e) {
        if (!swipe.active || !e.touches[0]) return;
        swipe.dx = e.touches[0].clientX - swipe.startX;
        setTrackPx(dragBaseOffset() + swipe.dx);
      }
      function onSwipeTouchEnd() {
        if (!swipe.active) return;
        swipe.active = false;
        track.style.transition = '';
        updateStep();
        var thr = Math.max(40, Math.min(80, (step || 1) * 0.2));
        if (swipe.dx <= -thr) {
          goNext();
        } else if (swipe.dx >= thr) {
          goPrev();
        } else {
          applyTransform();
        }
        swipe.dx = 0;
      }
      if (window.PointerEvent) {
        viewport.addEventListener('pointerdown', onSwipePointerDown);
        viewport.addEventListener('pointermove', onSwipePointerMove);
        viewport.addEventListener('pointerup', swipePointerEnd);
        viewport.addEventListener('pointercancel', swipePointerEnd);
      } else {
        viewport.addEventListener('touchstart', onSwipeTouchStart, { passive: true });
        viewport.addEventListener('touchmove', onSwipeTouchMove, { passive: true });
        viewport.addEventListener('touchend', onSwipeTouchEnd);
        viewport.addEventListener('touchcancel', onSwipeTouchEnd);
      }
      prevBtn.addEventListener('click', goPrev);
      nextBtn.addEventListener('click', goNext);
      if (typeof ResizeObserver !== 'undefined') {
        var ro = new ResizeObserver(function () {
          applyTransform();
        });
        ro.observe(viewport);
      }
      window.addEventListener('resize', applyTransform);
      applyTransform();
    });
  
;

    (function() {
      var section = document.getElementById('quiz-faq');
      if (!section) return;
      var items = section.querySelectorAll('[data-faq-item]');items.forEach(function(item) {
        var button = item.querySelector('.quiz-faq__button');
        var answer = item.querySelector('.quiz-faq__answer');
        var toggle = item.querySelector('.quiz-faq__toggle');
        if (!button || !answer || !toggle) return;
        button.addEventListener('click', function() {
          var isOpen = item.classList.contains('is-open');
          items.forEach(function(other) {
            if (other === item) return;
            other.classList.remove('is-open');
            var otherButton = other.querySelector('.quiz-faq__button');
            var otherToggle = other.querySelector('.quiz-faq__toggle');
            if (otherButton) otherButton.setAttribute('aria-expanded', 'false');
            if (otherToggle) otherToggle.textContent = '+';
          });
          item.classList.toggle('is-open', !isOpen);
          button.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
          toggle.textContent = isOpen ? '+' : '−';
        });
      });
    })();
  
;

(function () {
  var root = document.querySelector('.wlb-buy-root'); if (!root) return;
  // buy box: Subscribe (with a Delivered dropdown) or One time
  var cards = root.querySelectorAll('.wlb-option');
  var cancel = root.querySelector('[data-wlb-cancel]'), save = root.querySelector('[data-wlb-save]'), strike = root.querySelector('[data-wlb-strike]');
  var pw = root.querySelector('[data-wlb-price-whole]'), pc = root.querySelector('[data-wlb-price-cents]'), ps = root.querySelector('[data-wlb-price-suffix]');
  var freq = root.querySelector('[data-wlb-freq]'), note = root.querySelector('[data-wlb-freq-note]'), buy = root.querySelector('[data-wlb-checkout]');
  // Prices are the section's, read from the box product and its plan (ConnoisseurOfferData).
  var prices = { sub: pw.textContent + pc.textContent, onetime: '' };
  try { var od = JSON.parse(document.getElementById('ConnoisseurOfferData').textContent); prices.sub = od.subPrice; prices.onetime = od.onetimePrice; } catch (e) {}
  function sync() {
    var sub = root.querySelector('.wlb-option.is-selected').getAttribute('data-option') === 'sub';
    cancel.hidden = !sub; save.hidden = !sub; strike.hidden = !sub;
    var price = sub ? prices.sub : prices.onetime, dot = price.lastIndexOf('.');
    pw.textContent = dot > 0 ? price.slice(0, dot) : price; pc.textContent = dot > 0 ? price.slice(dot) : ''; var per = freq.value === '1' ? '/mo' : '/' + freq.value + ' mo'; ps.textContent = sub ? per : ''; ps.hidden = !sub; var cp = root.querySelector('[data-wlb-per]'); if (cp) cp.textContent = per;
    var plan = sub ? freq.value : 'onetime';
    var first = root.querySelector('[data-wlb-first]'), ft = root.querySelector('[data-wlb-first-thumb]'), k = sub ? 'sub' : 'once';
    if (first) { var src = first.getAttribute('data-' + k + '-src'); if (first.getAttribute('src') !== src) { var ss = first.getAttribute('data-' + k + '-srcset'); if (ss) first.setAttribute('srcset', ss); else first.removeAttribute('srcset'); first.setAttribute('src', src); first.setAttribute('alt', first.getAttribute('data-' + k + '-alt')); first.classList.toggle('wlb-cover', sub); if (ft) ft.setAttribute('src', ft.getAttribute('data-' + k + '-src') || src); var t0 = root.querySelector('.crb-hero-carousel__thumb'); if (t0 && !t0.classList.contains('crb-hero-carousel__thumb--active')) t0.click(); } }
    buy.setAttribute('data-plan', plan); root.setAttribute('data-selected-option', plan);
    document.querySelectorAll('[data-wlb-btn-price]').forEach(function (el) { el.textContent = price; });
    return { option: sub ? 'sub' : 'onetime', plan: plan, price: price };
  }
  // Analytics: queue + bubbling event, read by assets/analytics-posthog-funnel.js (connoisseur_offer_*).
  function announce(state, detail) {
    try {
      (window.__coOfferQueue = window.__coOfferQueue || []).push({ state: state, detail: detail });
      root.dispatchEvent(new CustomEvent('co-offer:' + state, { bubbles: true, detail: detail }));
    } catch (e) {}
  }
  // Desktop: switching options must not pull the page up. Picking One time collapses the Subscribe
  // card (the box got 139px shorter and everything under it jumped), so the box keeps the tallest
  // height it has had at this width. Phones keep the natural height (Harpawan: mobile looks right).
  var cardsBox = root.querySelector('.wlb-tp-cards'), desk = window.matchMedia('(min-width: 1101px)');
  function holdHeight() {
    if (!cardsBox) return;
    if (!desk.matches) { cardsBox.style.minHeight = ''; return; }
    var h = cardsBox.getBoundingClientRect().height;
    if (h > (parseFloat(cardsBox.style.minHeight) || 0)) cardsBox.style.minHeight = Math.ceil(h) + 'px';
  }
  if (desk.addEventListener) desk.addEventListener('change', function () { if (cardsBox) cardsBox.style.minHeight = ''; holdHeight(); });
  function pick(card) {
    holdHeight();
    cards.forEach(function (c) {
      var on = c === card;
      c.classList.toggle('is-selected', on); c.classList.toggle('tp-mm-card--selected', on); c.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    announce('selected', sync());
  }
  cards.forEach(function (c) {
    c.addEventListener('click', function (e) { if (c.classList.contains('is-selected')) return; pick(c); });
    c.addEventListener('keydown', function (e) { if (e.target === c && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); pick(c); } });
  });
  // Only a shopper's change is a selection; the checkout script re-syncs after dropping plans.
  freq.addEventListener('change', function (e) { var s = sync(); if (e.isTrusted) announce('selected', s); });
  freq.addEventListener('click', function (e) { e.stopPropagation(); });
  // customer videos: the still shows until the play button is tapped
  document.querySelectorAll('.wlb-ugc .mb-offer-ugc__play').forEach(function (btn) {
    btn.addEventListener('click', function () { var v = btn.parentNode.querySelector('video'); btn.hidden = true; v.controls = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); });
  });
  announce('viewed', sync());
  // phone sticky button: shown whenever neither the hero button nor the buy button itself is on screen.
  // Inside the buy box it presses the buy button; anywhere else it jumps to the buy box.
  var bar = document.querySelector('[data-wlb-sticky]'), buySec = document.getElementById('buy'), heroBtn = document.querySelector('.hero-bourbon__cta'), buyBtn = root.querySelector('[data-wlb-checkout]');
  if (bar && buySec && heroBtn && 'IntersectionObserver' in window) {
    var seen = { buy: true, hero: true }, heroPast = false, inBuy = false;
    var upd = function () {
      var show = !seen.buy && !seen.hero && heroPast;
      bar.classList.toggle('ql-cta-sticky--hidden', !show); bar.querySelector('a').tabIndex = show ? 0 : -1;
      document.body.classList.toggle('ql-cta-sticky-active', show);
    };
    new IntersectionObserver(function (en) { seen.buy = en[en.length - 1].isIntersecting; upd(); }).observe(buyBtn);
    new IntersectionObserver(function (en) { inBuy = en[en.length - 1].isIntersecting; }).observe(buySec);
    bar.querySelector('a').addEventListener('click', function (e) { if (inBuy) { e.preventDefault(); buyBtn.click(); } });
    new IntersectionObserver(function (en) { var e = en[en.length - 1]; seen.hero = e.isIntersecting; heroPast = e.boundingClientRect.bottom <= 0; upd(); }).observe(heroBtn);
  }
  // buy box gallery
  var imgs = root.querySelectorAll('.crb-hero-carousel__image'), dots = root.querySelectorAll('.crb-hero-carousel__dot'), thumbs = root.querySelectorAll('.crb-hero-carousel__thumb');
  var prev = root.querySelector('.crb-hero-carousel__arrow--prev'), next = root.querySelector('.crb-hero-carousel__arrow--next'), at = 0;
  function go(i) {
    at = Math.max(0, Math.min(imgs.length - 1, i));
    imgs.forEach(function (el, k) { el.classList.toggle('crb-hero-carousel__image--active', k === at); });
    dots.forEach(function (el, k) { el.classList.toggle('crb-hero-carousel__dot--active', k === at); el.setAttribute('aria-selected', k === at); });
    thumbs.forEach(function (el, k) { el.classList.toggle('crb-hero-carousel__thumb--active', k === at); el.setAttribute('aria-selected', k === at); });
    prev.disabled = at === 0; prev.classList.toggle('crb-hero-carousel__arrow--hidden', at === 0);
    next.disabled = at === imgs.length - 1; next.classList.toggle('crb-hero-carousel__arrow--hidden', at === imgs.length - 1);
  }
  prev.addEventListener('click', function () { go(at - 1); }); next.addEventListener('click', function () { go(at + 1); });
  dots.forEach(function (el, k) { el.addEventListener('click', function () { go(k); }); });
  thumbs.forEach(function (el, k) { el.addEventListener('click', function () { go(k); }); });
})();
